export interface OverallAnalysisUploader {
  id: string;
  name: string;
}

export interface OverallAnalysisResponse {
  uploaded_by: OverallAnalysisUploader | null;
  uploaded_at: string | null;
  updated_at: string | null;
  pdf: {
    filename: string;
    uploaded_by: OverallAnalysisUploader | null;
    uploaded_at: string | null;
    updated_at: string | null;
    can_download: boolean;
    password_setup_required: boolean;
  } | null;
  artifacts_completed_at: string | null;
  analysis_revision: number;
  /** 担当フィードバッカーの承認待ちかどうか */
  approval_pending: boolean;
  /** 閲覧者がこのセッションの全体分析を承認できるかどうか */
  can_approve: boolean;
  approved_at: string | null;
  approved_by: OverallAnalysisUploader | null;
}

export const OVERALL_ANALYSIS_PDF_MAX_BYTES = 20 * 1024 * 1024;
